export default __webpack_public_path__ + "static/media/Morocco.58612b03.png";